import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', () => {
  // State -----------------------------------------
  const isFlipBack = ref(false)

  // Getters ---------------------------------------

  // Actions ---------------------------------------
  function $reset() {
    isFlipBack.value = false
  }

  function setFlipBack(status) {
    isFlipBack.value = status
  }

  // Main Setup ------------------------------------

  // -----------------------------------------------
  return { isFlipBack, $reset, setFlipBack }
})